import { LOCAL_STORAGE_SERVICE_PACK_KEY } from "../../core/service/BusinessLogicService"
import { useLocalStorage } from "react-use"

export default function useLocalStorageServicePack() {
  const [getLocalStorageServicePackObject, setLocalStorageServicePack, remove] = useLocalStorage(
    LOCAL_STORAGE_SERVICE_PACK_KEY,
    {
      serializer: (value) => JSON.stringify(value),
      deserializer: (value) => JSON.parse(value)
    }
  )

  return {
    getLocalStorageServicePackObject,
    setLocalStorageServicePack,
    remove
  }
}
